import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import weui from "weui.js";
import {
  Cell,
  CellBody,
  CellButton,
  CellHeader,
  Cells,
  Input,
  Label
} from "../../components/weui";
import { payService, userService } from "../../services";
import { isAuthenticated, refreshRedux } from "../../stores";
import { urls } from "../../urls";
import { getAxiosError, isWechat } from "../../utils";

export const Login = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const loc = location.state?.from;
  const from = !loc ? urls.home() : `${loc.pathname || ""}${loc.search || ""}${loc.hash || ""}`;

  const logo = useSelector((state) => state.logo.logo);

  const [loading, setLoading] = useState(true);
  const [phone, setPhone] = useState("");
  const [pwd, setPwd] = useState("");
  const canLogin = useMemo(() => phone?.trim() && pwd?.trim(), [phone, pwd]);

  const wechatLogin = useCallback(async () => {
    const loading = weui.loading("微信登陆中");
    try {
      const res = await payService.getWechatLoginUrl(from);
      window.location.href = res.data;
    } catch (err) {
      weui.topTips(getAxiosError(err));
    } finally {
      loading.hide();
    }
  }, [from]);

  const checkAuth = useCallback(async () => {
    if (await isAuthenticated()) {
      navigate(from, { replace: true });
    } else {
      if (isWechat()) {
        await wechatLogin();
      } else {
        setLoading(false);
      }
    }
  }, [navigate, from, setLoading, wechatLogin]);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const handleLogin = async e => {
    e.preventDefault();
    const loading = weui.loading("登陆中...");
    try {
      await userService.login(phone, pwd);
      await refreshRedux();

      navigate(from, { replace: true });
    } catch (err) {
      weui.alert(getAxiosError(err), {
        title: "登陆失败"
      });
    } finally {
      loading.hide();
    }
  };
  if (loading) return <div></div>;

  return (
    <>
      <div className="my-10 flex flex-col items-center">
        <img src={ logo?.logoPath } alt="logo" className="w-24"></img>
      </div>

      <Cells>
        <Cell>
          <CellHeader>
            <Label>手机号</Label>
          </CellHeader>
          <CellBody>
            <Input type="phone" placeholder="请输入您的手机号" value={ phone } onChange={ e => setPhone(e.target.value) } />
          </CellBody>
        </Cell>
        <Cell>
          <CellHeader>
            <Label>密码</Label>
          </CellHeader>
          <CellBody>
            <Input type="password" placeholder="请输入您的密码" value={ pwd } onChange={ e => setPwd(e.target.value) } />
          </CellBody>
        </Cell>
      </Cells>

      <Cells className="mt-10">
        <CellButton type="primary" disabled={ !canLogin } onClick={ handleLogin }>登陆</CellButton>
      </Cells>

      { /* <div className="mt-5 text-center">
        <Link>没有账号？立即注册</Link>
      </div> */ }
    </>
  );
};
